import getInvoiceMerchantsSymbols from '../symbols/getInvoiceMerchants';
import { HttpRequestGet } from "../../service";
const getInvoiceMerchantsAction = () => ({
  type: getInvoiceMerchantsSymbols.GET_INVOICE_MERCHANTS,
});
const getInvoiceMerchantsSuccessAction = (data: any) => ({
  type: getInvoiceMerchantsSymbols.GET_INVOICE_MERCHANTS_SUCCESS,
  payload: data,
});
const getInvoiceMerchantsFailureAction = (data: any) => ({
  type: getInvoiceMerchantsSymbols.GET_INVOICE_MERCHANTS_FAILURE,
  payload: data,
});
const clearGetInvoiceMerchantsAction = () => ({
  type: getInvoiceMerchantsSymbols.CLEAR_GET_INVOICE_MERCHANTS,
});
export function getInvoiceMerchants(callback?: Function) {
  let url = '/admin/invoice/merchant';
  return (dispatch: any) => {
    dispatch(getInvoiceMerchantsAction());
    HttpRequestGet(
      url,
      dispatch,
      getInvoiceMerchantsSuccessAction,
      getInvoiceMerchantsFailureAction,
      true,
      callback
    );
  };
}

export function clearInvoiceMerchants() {
  return (dispatch: any) => {
    dispatch(clearGetInvoiceMerchantsAction());
  };
}
